import React from "react";
import PublicPage from "./PublicPage";
import LegalTabs from "./LegalTabs";

export default function Privacy() {
    return (
        <PublicPage kicker="&gt; legal.privacy" title="Privacy Policy" updated="July 2026" testid="page-privacy" tabs={<LegalTabs />}>
            <p>
                Vyaahar (operated by Vyastics Technologies Private Limited, "we", "us") respects your privacy. This
                policy describes what we collect, how we use it, and the choices you have.
            </p>
            <h2 className="vy-serif" style={{ fontSize: "1.35rem", marginTop: 32, color: "var(--vy-navy)" }}>What we collect</h2>
            <ul>
                <li><strong>Account data</strong> — name, work email, company, role.</li>
                <li><strong>Business data</strong> — invoices, bills, ledger entries, bank statements, and any other data you or your team upload.</li>
                <li><strong>Usage data</strong> — page views, feature clicks, IP address, and browser metadata used to keep the product secure and to prioritise fixes.</li>
            </ul>
            <h2 className="vy-serif" style={{ fontSize: "1.35rem", marginTop: 32, color: "var(--vy-navy)" }}>How we use it</h2>
            <ul>
                <li>To operate the product and provide the services you signed up for.</li>
                <li>To send transactional emails (invoice delivery, receipts, notifications).</li>
                <li>To keep the platform secure — detect abuse, fraud, and unauthorised access.</li>
                <li>To improve the product — aggregated, anonymised patterns only.</li>
            </ul>
            <h2 className="vy-serif" style={{ fontSize: "1.35rem", marginTop: 32, color: "var(--vy-navy)" }}>What we never do</h2>
            <ul>
                <li>We do not sell your data to third parties.</li>
                <li>We do not use your ledger, invoices, or bank data to train third-party AI models.</li>
                <li>We do not share your data with anyone outside our organisation except sub-processors listed below.</li>
            </ul>
            <h2 className="vy-serif" style={{ fontSize: "1.35rem", marginTop: 32, color: "var(--vy-navy)" }}>Sub-processors</h2>
            <p>
                We use a small set of vetted infrastructure providers to run Vyaahar — including MongoDB Atlas
                (database), Resend (transactional email), and cloud compute providers. All sub-processors sign
                data-processing agreements consistent with this policy.
            </p>
            <h2 className="vy-serif" style={{ fontSize: "1.35rem", marginTop: 32, color: "var(--vy-navy)" }}>Data retention</h2>
            <p>
                We retain your account and business data for as long as your account is active. If you cancel or
                delete your account, your data is retained for 30 days (to allow recovery in case of accidental
                deletion) and then permanently erased, except where we are legally required to retain certain
                records for longer.
            </p>
            <h2 className="vy-serif" style={{ fontSize: "1.35rem", marginTop: 32, color: "var(--vy-navy)" }}>Children's privacy</h2>
            <p>
                Vyaahar is not directed at, and is not intended for use by, anyone under the age of 18. We do not
                knowingly collect personal data from minors.
            </p>
            <h2 className="vy-serif" style={{ fontSize: "1.35rem", marginTop: 32, color: "var(--vy-navy)" }}>Your choices</h2>
            <p>
                You can request an export of your data, or ask us to delete your account, at any time by writing to
                {" "}<a href="mailto:hello@scitus.ai" style={{ color: "var(--vy-gold)" }}>hello@scitus.ai</a>. We will
                respond within a reasonable timeframe.
            </p>
            <h2 className="vy-serif" style={{ fontSize: "1.35rem", marginTop: 32, color: "var(--vy-navy)" }}>Contact</h2>
            <p>Questions about this policy? Email <a href="mailto:hello@scitus.ai" style={{ color: "var(--vy-gold)" }}>hello@scitus.ai</a>.</p>
        </PublicPage>
    );
}
